import {
  writeSelectedGroupId,
  writeSelectedMode,
} from '@modules/consolidator/utils/group-selection-storage/group-selection-storage'
import { FILTER_MODE } from '@modules/consolidator/constants/filter-mode'

// Actions
export const setViewMode = ({ commit }, payload) => {
  commit('SET_PREFERENCE_VIEW_MODE', payload)
}

export const setConsolidateExtracts = ({ commit }, payload) => {
  commit('SET_CONSOLIDATE_EXTRACTS', payload)
}
export const setConsolidateExtractsLoading = ({ commit }, payload) => {
  commit('SET_CONSOLIDATE_EXTRACTS_LOADING', payload)
}

export const setCotizacao = ({ commit }, payload) => {
  commit('SET_COTIZACAO', payload)
}
export const setCotizacaoLoading = ({ commit }, payload) => {
  commit('SET_COTIZACAO_LOADING', payload)
}

export const setOverview = ({ commit }, payload) => {
  commit('SET_OVERVIEW', payload)
}
export const setOverviewLoading = ({ commit }, payload) => {
  commit('SET_OVERVIEW_LOADING', payload)
}

export const setOverviewFilters = ({ commit }, payload) => {
  commit('SET_OVERVIEW_FILTERS', payload)
}
export const setOverviewFiltersLoading = ({ commit }, payload) => {
  commit('SET_OVERVIEW_FILTERS_LOADING', payload)
}

export const setAssetsLiquidity = ({ commit }, payload) => {
  commit('SET_ASSETS_LIQUIDITY', payload)
}
export const setAssetsLiquidityLoading = ({ commit }, payload) => {
  commit('SET_ASSETS_LIQUIDITY_LOADING', payload)
}

export const setClientAssets = ({ commit }, payload) => {
  commit('SET_CLIENT_ASSETS', payload)
}
export const setClientAssetsLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_ASSETS_LOADING', payload)
}

export const setSearchAssets = ({ commit }, payload) => {
  commit('SET_SEARCH_ASSETS', payload)
}
export const addSearchAssets = ({ commit }, payload) => {
  commit('ADD_SEARCH_ASSETS', payload)
}
export const setSearchAssetsLoading = ({ commit }, payload) => {
  commit('SET_SEARCH_ASSETS_LOADING', payload)
}

export const setClientDataOutdated = ({ commit }, payload) => {
  commit('SET_CLIENT_DATA_OUTDATED', payload)
}

export const setRecotizacaoEmAndamento = ({ commit }, payload) => {
  commit('SET_RECOTIZACAO_EM_ANDAMENTO', payload)
}

export const addRecentlyLinkedAsset = ({ commit }, payload) => {
  commit('ADD_RECENTLY_LINKED_ASSET', payload)
}

export const setVersionClosing = ({ commit }, payload) => {
  commit('SET_VERSION_CLOSING', payload)
}
export const setVersionClosingLoading = ({ commit }, payload) => {
  commit('SET_VERSION_CLOSING_LOADING', payload)
}
export const setBackOfficeComparison = ({ commit }, payload) => {
  commit('SET_BACK_OFFICE_COMPARISON', payload)
}
export const addBackOfficeComparison = ({ commit }, payload) => {
  commit('ADD_BACK_OFFICE_COMPARISON', payload)
}
export const setBackOfficeComparisonLoading = ({ commit }, payload) => {
  commit('SET_BACK_OFFICE_COMPARISON_LOADING', payload)
}

export const setInvestmentAccount = ({ commit }, payload) => {
  commit('SET_INVESTMENT_ACCOUNT', payload)
}
export const setInvestmentAccountLoading = ({ commit }, payload) => {
  commit('SET_INVESTMENT_ACCOUNT_LOADING', payload)
}

export const setFullWallet = ({ commit }, payload) => {
  commit('SET_FULL_WALLET', payload)
}

export const setFullWalletBrokers = ({ commit }, payload) => {
  commit('SET_FULL_WALLET_BROKERS', payload)
}

export const setFullWalletPortfolio = ({ commit }, payload) => {
  commit('SET_FULL_WALLET_PORTFOLIO', payload)
}
export const setCorrelations = ({ commit }, payload) => {
  commit('SET_CORRELATIONS', payload)
}
export const setCorrelationsLoading = ({ commit }, payload) => {
  commit('SET_CORRELATIONS_LOADING', payload)
}

export const setRiskMetrics = ({ commit }, payload) => {
  commit('SET_RISK_METRICS', payload)
}
export const setRiskMetricsLoading = ({ commit }, payload) => {
  commit('SET_RISK_METRICS_LOADING', payload)
}

export const setInsightsIa = ({ commit }, payload) => {
  commit('SET_INSIGHTS_IA', payload)
}
export const setInsightsIaLoading = ({ commit }, payload) => {
  commit('SET_INSIGHTS_IA_LOADING', payload)
}
export const setAnalisysAdvanced = ({ commit }, payload) => {
  commit('SET_ANALISYS_ADVANCED', payload)
}
export const setAnalisysAdvancedLoading = ({ commit }, payload) => {
  commit('SET_ANALISYS_ADVANCED_LOADING', payload)
}

export const setCarteiraAtivos = ({ commit }, payload) => {
  commit('SET_CARTEIRA_ATIVOS', payload)
}
export const setCarteiraAtivosLoading = ({ commit }, payload) => {
  commit('SET_CARTEIRA_ATIVOS_LOADING', payload)
}

export const setInvestmentAccounts = ({ commit }, payload) => {
  commit('SET_INVESTMENT_ACCOUNTS', payload)
}
export const setInvestmentAccountsLoading = ({ commit }, payload) => {
  commit('SET_INVESTMENT_ACCOUNTS_LOADING', payload)
}

export const setSimulatorResult = ({ commit }, payload) => {
  commit('SET_SIMULATOR_RESULT', payload)
}
export const setSimulatorResultLoading = ({ commit }, payload) => {
  commit('SET_SIMULATOR_RESULT_LOADING', payload)
}

export const setWalletFiltersModo = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_MODO', payload)
}
export const setWalletFiltersCorretora = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_CORRETORA', payload)
}
export const setWalletFiltersData = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_DATA', payload)
}
export const setWalletFiltersInvestmentType = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_INVESTMENT_TYPE', payload)
}
export const setWalletFiltersLastValidData = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_LAST_VALID_DATA', payload)
}
export const setWalletFiltersDataInicio = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_DATA_INICIO', payload)
}
export const setWalletFiltersDataFim = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_DATA_FIM', payload)
}
export const setWalletFiltersTipo = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_TIPO', payload)
}
export const setWalletFiltersSubtipo = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_SUBTIPO', payload)
}
export const setWalletFiltersClasse = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_CLASSE', payload)
}
export const setWalletFiltersSubclasse = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_SUBCLASSE', payload)
}
export const setWalletFiltersSetor = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_SETOR', payload)
}
export const setWalletFiltersEmissor = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_EMISSOR', payload)
}
export const setWalletFiltersIdConta = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_ID_CONTA', payload)
}
export const setWalletFiltersTags = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_TAGS', payload)
}
export const setWalletFiltersInstituicao = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_INSTITUICAO', payload)
}
export const setWalletFiltersPortfolio = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_PORTFOLIO', payload)
}
export const setWalletFiltersUserChangedField = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_USER_CHANGED_FIELD', payload)
}
export const setWalletFiltersAll = ({ commit }, payload) => {
  commit('SET_WALLET_FILTERS_ALL', payload)
}
export const resetWalletFilters = ({ commit }) => {
  commit('RESET_WALLET_FILTERS')
}

export const setWalletAnalysis = ({ commit }, payload) => {
  commit('SET_WALLET_ANALYSIS', payload)
}
export const setWalletAnalysisLoading = ({ commit }, payload) => {
  commit('SET_WALLET_ANALYSIS_LOADING', payload)
}

export const setWalletAnalysisOptionsFields = ({ commit }, payload) => {
  commit('SET_WALLET_ANALYSIS_OPTIONS_FIELDS', payload)
}
export const setWalletAnalysisOptionsFieldsLoading = ({ commit }, payload) => {
  commit('SET_WALLET_ANALYSIS_OPTIONS_FIELDS_LOADING', payload)
}

export const setStatisticsPerAsset = ({ commit }, payload) => {
  commit('SET_STATISTICS_PER_ASSET', payload)
}
export const setStatisticsPerAssetLoading = ({ commit }, payload) => {
  commit('SET_STATISTICS_PER_ASSET_LOADING', payload)
}

export const setAssetSeries = ({ commit }, payload) => {
  commit('SET_ASSET_SERIES', payload)
}

export const setAssetSeriesBenchmarks = ({ commit }, payload) => {
  commit('SET_ASSET_SERIES_BENCHMARKS', payload)
}

export const setPortfolios = ({ commit }, payload) => {
  commit('SET_PORTFOLIOS', payload)
}
export const setPortfoliosLoading = ({ commit }, payload) => {
  commit('SET_PORTFOLIOS_LOADING', payload)
}

export const setProventos = ({ commit }, payload) => {
  commit('SET_PROVENTOS', payload)
}
export const setProventosLoading = ({ commit }, payload) => {
  commit('SET_PROVENTOS_LOADING', payload)
}

export const setSplits = ({ commit }, payload) => {
  commit('SET_SPLITS', payload)
}
export const setSplitsLoading = ({ commit }, payload) => {
  commit('SET_SPLITS_LOADING', payload)
}

// Seleção de grupo reseta os filtros: manter um filtro de conta ou de membro do
// grupo anterior mostraria a carteira do grupo novo com um recorte que o
// usuário não pediu.
export const selectFamilyGroup = ({ commit }, payload) => {
  commit('SET_CURRENT_FAMILY_GROUP', payload)
  commit('RESET_FAMILY_GROUP_FILTERS')
}

export const clearFamilyGroupSelection = ({ commit, rootGetters }) => {
  const usuario = (rootGetters && rootGetters['user/currentUser']) || {}
  writeSelectedGroupId(usuario.id, null)
  writeSelectedMode(usuario.id, FILTER_MODE.CLIENTES)
  commit('SET_CURRENT_FAMILY_GROUP', null)
  commit('SET_WALLET_SELECTOR_MODE', FILTER_MODE.CLIENTES)
  commit('RESET_FAMILY_GROUP_FILTERS')
}

// Re-commita o MESMO grupo com o objeto novo da listagem, SEM resetar filtros.
// `selectFamilyGroup` nao serve aqui: ele reseta o recorte, e recarregar a
// listagem depois de vincular/remover um membro nao e trocar de grupo.
// Sem isto o `currentFamilyGroup` fica congelado no snapshot da selecao — e o
// membro adicionado na sessao nao tinha `id_vinculo`, entao a lixeira da tabela
// respondia "nao foi possivel identificar o vinculo deste membro".
export const refreshCurrentFamilyGroup = ({ commit }, payload) => {
  if (!payload) return
  commit('SET_CURRENT_FAMILY_GROUP', payload)
}

export const setWalletSelectorMode = ({ commit }, payload) => {
  commit('SET_WALLET_SELECTOR_MODE', payload)
}

// Persistência da carteira do grupo. Quem busca é a classe de API
// `apiConsolidatorGroupWalletAnalysis` — nenhuma action faz request.
export const setFamilyGroupWallet = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_WALLET', payload)
}
export const setFamilyGroupLoading = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_WALLET_LOADING', payload)
}

export const setFamilyGroupAssetStatistics = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_ASSET_STATISTICS', payload)
}
export const setFamilyGroupAssetStatisticsLoading = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_ASSET_STATISTICS_LOADING', payload)
}

export const setFamilyGroupMemberBreakdown = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_MEMBER_BREAKDOWN', payload)
}
export const setFamilyGroupMemberBreakdownLoading = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_MEMBER_BREAKDOWN_LOADING', payload)
}

export const setFamilyGroupFilters = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_FILTERS', payload)
}
export const resetFamilyGroupFilters = ({ commit }) => {
  commit('RESET_FAMILY_GROUP_FILTERS')
}

export const setFamilyGroupOptionsFields = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_OPTIONS_FIELDS', payload)
}
export const setFamilyGroupOptionsFieldsLoading = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_OPTIONS_FIELDS_LOADING', payload)
}
